import * as z from 'zod'

import type { TDoc, TEntity } from '#firebase/firestoreSchemas'

import { timestampSchema } from '../schemas'

const questionIdSchema = z.string().trim().min(1)

export const answerValueSchema = z
  .union([z.string(), z.int(), z.float32(), z.boolean(), timestampSchema])
  .nullable()

export const answersSchema = z.record(questionIdSchema, answerValueSchema)

export const submissionSchema = z.object({
  topicId: z.string(),
  answers: answersSchema,
})

export type QuestionID = z.output<typeof questionIdSchema>
export type SubmissionAnswerValue = z.output<typeof answerValueSchema>
export type SubmissionAnswers = z.infer<typeof answersSchema>

export type Submission = TEntity<typeof submissionSchema>
export type SubmissionDoc = TDoc<typeof submissionSchema>
